import { differenceInHoursDateUtil } from 'packages/src'
import getItemLocalStorageUtil from 'modules/local-storage/get-item'
import { PROFILE_LOCAL_STORAGE_KEY } from 'modules/profile/constants/index.js'
import { PROFILE_FITNESS_DATA_MODAL_SHOWN_AT_DIFF_HOURS } from 'modules/profile/redux/actions/should-show-fitness-data-modal/index.js'

/**
 * Check if the onboarding modal was shown recently (within PROFILE_FITNESS_DATA_MODAL_SHOWN_AT_DIFF_HOURS)
 * @param {boolean} isProfileIncomplete - If true, always return false to show the modal
 * @returns {boolean} - True if modal was shown recently, false otherwise
 */
export const hasSeenOnboardingModalRecentlyProfileUtil = (isProfileIncomplete) => {
  // For new profiles with incomplete data, always show the modal
  if (isProfileIncomplete) {
    return false
  }

  const shownAt = getItemLocalStorageUtil(
    PROFILE_LOCAL_STORAGE_KEY.PROFILE_FITNESS_DATA_MODAL_SHOWN_AT
  )

  if (!shownAt) {
    return false
  }

  const shownAtDate = new Date(shownAt)

  // Check if the date is valid
  if (isNaN(shownAtDate.getTime())) {
    return false
  }

  const shownAtDiffHours = differenceInHoursDateUtil(new Date(), shownAtDate)

  return shownAtDiffHours < PROFILE_FITNESS_DATA_MODAL_SHOWN_AT_DIFF_HOURS
}
